module.exports = __WEBPACK_EXTERNAL_MODULE__wufe_particles__;